module.exports = __webpack_public_path__ + "image/quotationright_ic.7ab6cd4c.png";